import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./scss/main.scss";
import "./scss/index.css";
import "utils/internationalization";

ReactDOM.render(<App />, document.getElementById("root"));
